import api from './api';
import { CustomerLocation } from '../types';

export const customerLocationsService = {
  getByCustomerId: async (
    customerId: string,
    isActive?: boolean
  ): Promise<CustomerLocation[]> => {
    const params = isActive !== undefined ? { isActive } : {};
    const response = await api.get<CustomerLocation[]>(
      `/customers/${customerId}/locations`,
      { params }
    );
    return response.data;
  },

  getById: async (
    customerId: string,
    id: string
  ): Promise<CustomerLocation> => {
    const response = await api.get<CustomerLocation>(
      `/customers/${customerId}/locations/${id}`
    );
    return response.data;
  },

  create: async (
    customerId: string,
    data: Partial<CustomerLocation>
  ): Promise<CustomerLocation> => {
    const response = await api.post<CustomerLocation>(
      `/customers/${customerId}/locations`,
      data
    );
    return response.data;
  },

  update: async (
    customerId: string,
    id: string,
    data: Partial<CustomerLocation>
  ): Promise<CustomerLocation> => {
    const response = await api.patch<CustomerLocation>(
      `/customers/${customerId}/locations/${id}`,
      data
    );
    return response.data;
  },

  delete: async (customerId: string, id: string): Promise<void> => {
    await api.delete(`/customers/${customerId}/locations/${id}`);
  },
};
